import AuthClass from '../library/AuthClass';

var auth = new AuthClass();
export default auth;